<template>
  <a @click="trigger">
    <slot>
      <MIcon name="hand-receiving" class="action-menu-icon" />
      <span class="ml-1 action-menu-text">
        {{ $tc('receive') }} {{ $tc('item', 2) }}
      </span>
    </slot>
    <FlotoDrawerForm
      ref="drawer"
      :open="isDrawerOpen"
      width="70%"
      @cancel="cancelAction"
      @submit="handleSubmit"
    >
      <template v-slot:header>
        {{ $t('receive') }} {{ $tc('item', 2) }}
      </template>
      <template v-slot:trigger> </template>
      <OrderItemSection
        v-model="formValue"
        disabled
        hide-total
        :custom-form-fields="priceCustomFields"
        :vendor-id="purchase.vendorId"
        :hidden-columns="['amount', 'partNumber', 'price', 'taxRate']"
        can-editeceived-quantity
      />
      <template v-slot:actions="{ submit, hide }">
        <span class="mr-2 text-neutral-light">
          * {{ __tc('to_create_asset_note') }}
        </span>
        <MButton :loading="processing" @click="submit">
          {{ $t('update') }}
        </MButton>
        <MButton variant="default" class="ml-2" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawerForm>
  </a>
</template>
<script>
import CloneDeep from 'lodash/cloneDeep'
import { calculateTotal } from '../helpers/utils'
import OrderItemSection from './form-components/order-item-section'
import { updateReceivedItemApi } from '../purchase-api'
export default {
  name: 'ReceiveItemDrawer',
  components: { OrderItemSection },
  props: {
    purchase: { type: Object, required: true },
    priceCustomFields: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      isDrawerOpen: false,
      formData: {},
      processing: false,
    }
  },
  computed: {
    formValue: {
      get() {
        return this.formData
      },
      set(value) {
        this.formData = {
          ...value,
          ...((value.itemList || []).length
            ? calculateTotal(value, this.priceCustomFields)
            : {}),
        }
      },
    },
  },
  methods: {
    trigger() {
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 400)
      this.formData = CloneDeep(this.purchase)
      this.$emit('trigger')
    },
    cancelAction() {
      this.isDrawerOpen = false
    },
    handleSubmit() {
      if (this.processing) {
        return
      }
      this.processing = true
      updateReceivedItemApi({
        id: this.purchase.id,
        itemList: this.formValue.itemList,
      })
        .then(() => {
          this.cancelAction()
          setTimeout(() => {
            this.processing = false
          }, 450)
          this.$emit('refresh')
        })
        .finally(() => (this.processing = false))
    },
  },
}
</script>
